import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Select } from '@guildeducationinc/recess';
import { useEffect, useMemo } from 'react';
import { useFields } from '../../hooks/useFields';
import { DropdownSelect } from '../DropdownSelect';
/**
 * A component that renders a field picker.
 */
export const FieldPicker = (props) => {
    const { items, loading } = useFields({
        clientId: props.clientId,
        entityType: props.entityType,
    });
    function getOptionValue(field) {
        if (props.getOptionValue) {
            return props.getOptionValue(field);
        }
        return field.code;
    }
    const options = useMemo(() => {
        return items?.map(field => ({ value: getOptionValue(field), label: field.name })) ?? [];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items]);
    useEffect(() => {
        if (!loading && props.value && props.onInit) {
            // console.log('onInit', items, props.value);
            props.onInit(items?.find(x => getOptionValue(x) === props.value));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading]);
    /**
     * Handles the change event of the select component.
     * @param event The select change event.
     */
    const handleOnChange = (event) => {
        if (props.onChange) {
            props.onChange(items?.find(x => getOptionValue(x) === event.target.value));
        }
    };
    return (_jsx(_Fragment, { children: !loading && (_jsxs(_Fragment, { children: [props.useMui && (_jsx(DropdownSelect, { label: props.label ?? '', onChange: handleOnChange, options: options, className: props.className, value: props.value, errors: props.errors, disabled: props.readonly })), !props.useMui && (_jsx(Select, { label: props.label ?? '', onChange: handleOnChange, options: options, className: props.className, value: props.value, errors: props.errors, disabled: props.readonly, isSearchable: props.isSearchable }))] })) }));
};
